import './App.css';
import CurrencyData from "./components/CurrencyData/CurrencyData"

function App() {
  return (
    <div className="App">
      <CurrencyData />
    </div>
  );
}

export default App;
